import * as R from 'remeda'
import { match } from 'ts-pattern'

/**
 * 単位なし文字列を"pts"単位付き文字列にフォーマットします。
 *
 * @param numText - 単位なし文字列。
 * @returns "pts"単位付き文字列。
 */
export function addPtsUnit(numText: string) {
  return match(numText)
    .with('NaN', R.identity())
    .otherwise((text) => `${text}pts`)
}
